'use strict';
// https://github.com/tc39/proposal-change-array-by-copy
require('../modules/esnext.array.to-reversed');
require('../modules/esnext.array.to-sorted');
require('../modules/esnext.array.to-spliced');
require('../modules/esnext.array.with');
require('../modules/esnext.typed-array.to-reversed');
require('../modules/esnext.typed-array.to-sorted');
// TODO: Remove from `core-js@4`
require('../modules/esnext.typed-array.to-spliced');
require('../modules/esnext.typed-array.with');
